import { render, staticRenderFns } from "./EventListComponent.vue?vue&type=template&id=7af40b72&scoped=true"
import script from "./EventListComponent.vue?vue&type=script&lang=js"
export * from "./EventListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af40b72",
  null
  
)

export default component.exports